export default __webpack_public_path__ + "static/media/1.70404935.jpeg";